import React, { useState, useEffect, useContext } from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import SchoolIcon from "@material-ui/icons/School";
import { ClassroomApi, ClassroomDto } from "../../api-clients/api";
import { getApiUrl } from "../../api-clients";
import Loading from "../Shared/Loading";
import NoResult from "../Shared/NoResult";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { useHistory } from "react-router-dom";
import { SearchBox } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { SchoolContext } from "../../contexts/SchoolContext";

initializeIcons();

export default function CardClassrooms() {
  const { t } = useTranslation();
  const history = useHistory();
  const { classroomUpdated, setClassroomUpdated } = useContext(SchoolContext);
  const [classroomApi] = useState<ClassroomApi>(new ClassroomApi(getApiUrl()));
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [classrooms, setClassrooms] = useState<ClassroomDto[]>([]);
  const [searchText, setSearchText] = useState<string>("");

  useEffect(() => {
    setIsLoading(true);
    setClassroomUpdated(false);
    classroomApi
      .getAll()
      .then((res) => {
        setClassrooms(res);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [classroomApi, classroomUpdated, setClassroomUpdated]);

  const filteredClassrooms = classrooms.filter(
    (c) =>
      (c.name ?? "").toLowerCase().includes(searchText.toLowerCase()) ||
      (c.acronym ?? "").toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <Card>
      <CardHeader title={t("classrooms.title")} />
      <CardContent>
        <Grid container spacing={1}>
          <Grid item sm={12} xs={12}>
            <SearchBox
              placeholder={t("classrooms.searchPlaceholder")}
              value={searchText}
              onChange={(event, newValue) => setSearchText(newValue ?? "")}
              onClear={() => setSearchText("")}
            />
          </Grid>
        </Grid>
        {!isLoading ? (
          filteredClassrooms.length > 0 ? (
            <List>
              {filteredClassrooms.map((c) => (
                <div key={c.classroomId}>
                  <ListItem
                    button
                    alignItems="flex-start"
                    onClick={() =>
                      history.push("/classroom-management/" + c.classroomId)
                    }
                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <SchoolIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={c.name} secondary={c.educationName} />
                  </ListItem>
                  <Divider />
                </div>
              ))}
            </List>
          ) : (
            <NoResult />
          )
        ) : (
          <Loading />
        )}
      </CardContent>
    </Card>
  );
}
